"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var text_utils_1 = require("../../../../common/text_utils");
var viewmodel_types_1 = require("../../layout/types/viewmodel_types");
var viewmodel_1 = require("../../layout/viewmodel/viewmodel");
function render(spec, chartDimensions, heatmapTable, colorScale, bandsToHide, gridHeightParams, theme) {
    var textMeasurer = document.createElement('canvas');
    var textMeasurerCtx = textMeasurer.getContext('2d');
    if (!textMeasurerCtx) {
        return (0, viewmodel_types_1.nullShapeViewModel)();
    }
    return (0, viewmodel_1.shapeViewModel)((0, text_utils_1.measureText)(textMeasurerCtx), spec, theme, chartDimensions, heatmapTable, colorScale, bandsToHide, gridHeightParams);
}
exports.render = render;
//# sourceMappingURL=scenegraph.js.map